import { Form, Button } from "react-bootstrap";

const MaestrasSelector = ({
  maestras,
  selectedMaestras,
  handleToggle,
  setSelectedMaestras,
}) => {
  const toggleAll = () => {
    const allSelected = selectedMaestras.length === maestras.length;
    setSelectedMaestras(allSelected ? [] : maestras.map((m) => m.rut));
  };

  return (
    <>
      <span style={{ width: "100%", display: "flex", marginBottom: "5px" }}>
        Seleccionar Maestras
      </span>
      <Button
        variant={
          selectedMaestras.length === maestras.length
            ? "outline-danger"
            : "outline-primary"
        }
        size="sm"
        className="mb-2"
        onClick={toggleAll}
      >
        {selectedMaestras.length === maestras.length
          ? "Deseleccionar Todas"
          : "Seleccionar Todas"}
      </Button>
      {maestras.map((maestra) => (
        <div
          key={maestra.rut}
          className={`asistencia-modal-maestra ${selectedMaestras.includes(maestra.rut) ? "selected" : ""}`}
          onClick={() => handleToggle(maestra.rut)}
        >
          <img
            className="mini-icon"
            src={
              maestra.imagen ||
              "https://cdn-redmaestra-endpoint.azureedge.net/static/images/default.png"
            }
            alt={maestra.nombre}
          />
          <Form.Check
            type="checkbox"
            label={maestra.nombre}
            checked={selectedMaestras.includes(maestra.rut)}
            onChange={() => handleToggle(maestra.rut)}
          />
        </div>
      ))}
    </>
  );
};
export default MaestrasSelector;
